import React, { useRef, useEffect } from 'react';
import './style.scss';
import coinImage from '../../../assets/images/coins_display.png';
import roadImg from '../../../assets/images/progress_road.png';
import car from '../../../assets/images/car.png';
import timer from '../../../assets/images/time_display.png';
import { connect } from 'react-redux';
import useCounter from '../../../utils/useCounter';

const GameStatusBar = ({
  coins,
  time,
  currentsceneId,
  screenID,
  sceneDataList,
}) => {
  const carRef = useRef(null);
  const roadRef = useRef(null);
  useEffect(() => {
    const id = sceneDataList.find((scene) => scene.sceneID === screenID);
    if (currentsceneId !== 'PRE_GAME_HELP') {
      carRef.current.style.right = `${id.percentage - 10}%`;
    }
    // eslint-disable-next-line
  }, [screenID]);

  const [minutes, sec] = useCounter();

  return (
    <>
      <div className="staus__bar__container">
        <div className="coins_container">
          <img className="coins__display__img" src={coinImage} alt="coins" />
          <div className="coins">{coins}</div>
        </div>
        <div className="progress__bar__container">
          {/* <img
            ref={roadRef}
            src={roadImg}
            alt="road for progess"
            className="road"
          /> */}
          <img ref={carRef} src={car} alt="car on road" className="car" />
        </div>
        <div className="timer__container">
          <img src={timer} alt="game timer" className="timer" />
          <div className="time">
            {currentsceneId !== 'PRE_GAME_HELP' ? (
              <>
                {`0${minutes}`}:{sec < 10 ? `0${sec}` : sec}
              </>
            ) : (
              <>3:00</>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    coins: state.trackingUser.user.coins,
    currentsceneId: state.screenChange.screenID,
    sceneDataList: state.shuffleData.sceneDataList,
    screenID: state.screenChange.screenID,
  };
};

export default connect(mapStateToProps)(GameStatusBar);
